import script from "./WatermarkLayer.vue?vue&type=script&setup=true&lang=js"
export * from "./WatermarkLayer.vue?vue&type=script&setup=true&lang=js"

import "./WatermarkLayer.vue?vue&type=style&index=0&id=57682128&scoped=true&lang=css"

import exportComponent from "/home/passani/git_repos/onlineimageoptimizer.com/image-optimizer-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57682128"]])

export default __exports__